import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FaFile } from "react-icons/fa6";
import { cx } from "@/lib/tailwind-utils";
const TILE_BASE = "flex items-center gap-2 rounded-lg border px-3 py-2 transition-colors";
interface ChatFileTileProps {
  label: string;
  /** Full name on hover when `label` is a collapsed stand-in. */
  title?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  /** Trailing control, e.g. a download button. */
  action?: React.ReactNode;
  className?: string;
  labelClassName?: string;
  ariaLabel?: string;
}

/**
 * One document attachment. Colours come from the caller because the tile is
 * rendered both on the page background and inside a bubble that recolours
 * every descendant.
 */
export function ChatFileTile(t0) {
  const $ = _c(24);
  const {
    label,
    title,
    icon,
    onClick,
    action,
    className,
    labelClassName,
    ariaLabel
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = icon ?? <FaFile className="shrink-0 !text-muted-foreground" size={16} />;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== labelClassName) {
    t2 = cx("truncate", labelClassName);
    $[2] = labelClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label || $[5] !== t2 || $[6] !== title) {
    t3 = <span className={t2} title={title}>{label}</span>;
    $[4] = label;
    $[5] = t2;
    $[6] = title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== action || $[9] !== t1 || $[10] !== t3) {
    t4 = <>{t1}{t3}{action}</>;
    $[8] = action;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const content = t4;
  if (onClick) {
    let t5;
    if ($[12] !== className) {
      t5 = cx(TILE_BASE, className);
      $[12] = className;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== ariaLabel || $[15] !== content || $[16] !== onClick || $[17] !== t5) {
      t6 = <button type="button" onClick={onClick} aria-label={ariaLabel} className={t5}>{content}</button>;
      $[14] = ariaLabel;
      $[15] = content;
      $[16] = onClick;
      $[17] = t5;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    return t6;
  }
  let t5;
  if ($[19] !== className) {
    t5 = cx(TILE_BASE, className);
    $[19] = className;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== content || $[22] !== t5) {
    t6 = <div className={t5}>{content}</div>;
    $[21] = content;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}

/** Placeholder for an attachment that is still uploading. */
export function ChatFileTileSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex animate-pulse items-center gap-2 rounded-lg border border-border bg-muted px-3 py-2"><FaFile className="shrink-0 !text-muted-foreground" size={16} /><span className="max-w-[200px] truncate text-body !text-foreground-secondary">Loading...</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}